import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import { AxisDateTimeFull } from "../util/AxisDateTime";

const UserShortOverview = ({ user }) => {
  return (
    <Fragment>
      <div>
        <h2 className={"icon-text-wrapper"}>
          {user?.surname} {user?.forename}{" "}
          <span
            className={
              "text-capitalize status-pill ms-3 " +
              user?.status.toLowerCase() +
              "-pill"
            }
          >
            {user?.status.toLowerCase()}
          </span>
        </h2>
      </div>
      <Table striped bordered hover>
        <tbody>
          {user?.status === "HOLD" ? (
            <>
              <tr>
                <td className={"tw-4"}>On Hold Reason</td>
                <td>{user?.onHoldReason}</td>
              </tr>
              <tr>
                <td className={"tw-4"}>On Hold Date</td>
                <td>{AxisDateTimeFull(user?.onHoldDate)}</td>
              </tr>
            </>
          ) : null}

          <tr>
            <td className={"tdw-50"}>Role</td>
            <td>{user?.role}</td>
          </tr>

          <tr>
            <td>NMC No</td>
            <td>{user?.nmcNumber}</td>
          </tr>

          <tr>
            <td>Staff Number</td>
            <td>{user?.staffNumber}</td>
          </tr>

          <tr>
            <td>Access NI Number</td>
            <td>{user?.accessNINumber}</td>
          </tr>

          <tr>
            <td>Access NI Expiry</td>
            <td>{user?.accessNIExpiry}</td>
          </tr>

          <tr>
            <td>E-Learning Username</td>
            <td>{user?.eLearnUsername}</td>
          </tr>

          <tr>
            <td>App Version</td>
            <td>{user?.appVersion}</td>
          </tr>

          <tr>
            <td>Device Type</td>
            <td>{user?.deviceType}</td>
          </tr>
        </tbody>
      </Table>
    </Fragment>
  );
};

export default UserShortOverview;
